import React from 'react'
import { upgradesEnabled } from '../../../lib/featureFlags'
import { useDashboard } from '../DashboardContext'
import { PlanPickerModal } from './PlanPickerModal'

function daysRemaining(trialEnd: string): number {
  const ms = new Date(trialEnd).getTime() - Date.now()
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)))
}

export function TrialBanner() {
  const { currentSubscription } = useDashboard()
  const [dismissed, setDismissed] = React.useState(false)
  const [planPickerOpen, setPlanPickerOpen] = React.useState(false)

  const sub = currentSubscription?.subscription
  if (!sub || sub.status !== 'TRIALING' || !sub.trialEnd) return null
  if (dismissed) return null

  const days = daysRemaining(sub.trialEnd)
  const urgent = days <= 3

  const bg        = urgent ? 'rgba(220,38,38,0.07)'  : 'rgba(224,90,43,0.07)'
  const border    = urgent ? 'rgba(220,38,38,0.22)'  : 'rgba(224,90,43,0.18)'
  const accentBd  = urgent ? '#dc2626'               : 'var(--accent)'
  const btnBg     = urgent ? '#dc2626'               : 'var(--accent)'

  const label = days === 0
    ? 'Your Pro trial ends today — upgrade to keep access.'
    : `${days} day${days === 1 ? '' : 's'} left in your Pro trial.`

  return (
    <>
      <div style={{ padding: '16px 28px 0' }}>
        <div
          role="alert"
          style={{
            background: bg,
            border: `1px solid ${border}`,
            borderLeft: `3px solid ${accentBd}`,
            borderRadius: 14,
            padding: '12px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            flexWrap: 'wrap',
            boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
          }}
        >
          <div style={{ fontSize: 13, color: 'var(--text)', flex: 1 }}>
            {label}{' '}
            <span style={{ color: 'var(--text2)', fontSize: 12 }}>
              Upgrade anytime to keep the full feature set.
            </span>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
            <button
              onClick={() => upgradesEnabled && setPlanPickerOpen(true)}
              disabled={!upgradesEnabled}
              title={upgradesEnabled ? undefined : 'Upgrades not available yet'}
              className="inline-flex items-center gap-1.5 px-[18px] py-[7px] rounded-full text-[12.5px] font-bold text-white border border-black shadow-[2px_2px_0_#111] transition-all duration-150 whitespace-nowrap
                enabled:hover:-translate-x-[1px] enabled:hover:-translate-y-[1px] enabled:hover:shadow-[3px_3px_0_#111]
                enabled:active:translate-x-[1px] enabled:active:translate-y-[1px] enabled:active:shadow-[1px_1px_0_#111]
                disabled:opacity-50 disabled:cursor-not-allowed"
              style={{
                background: btnBg,
                fontFamily: 'Manrope, sans-serif',
                cursor: upgradesEnabled ? 'pointer' : 'not-allowed',
              }}
            >
              Upgrade now
            </button>
            {!urgent && (
              <button
                onClick={() => setDismissed(true)}
                aria-label="Dismiss trial banner"
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'var(--text3)',
                  padding: 4,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 6,
                }}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
      {upgradesEnabled && planPickerOpen && <PlanPickerModal onClose={() => setPlanPickerOpen(false)} />}
    </>
  )
}
